import { CFPInputField, useCFPValues } from '@bcp-channels-sharedcomponents-reactjs/cf-proxy';
import { Box } from '@bcp-nextgen-dx-component-factory/design-system';
import { UIHelper } from '@helpers';
import { useTranslation } from '@hooks';

import { ComposableTypographyWithTooltip } from '../composableTypographyWithTooltip';

const resources = {
	title: 'screens.login.form.token.title',
	tooltip: {
		title: 'screens.login.form.token.tooltip.title',
		description: 'screens.login.form.token.tooltip.description',
	},
	input1: {
		label: 'screens.login.form.token.input1.label',
		hint: 'screens.login.form.token.input1.hint',
	},
	input2: {
		label: 'screens.login.form.token.input2.label',
		hint: 'screens.login.form.token.input2.hint',
	},
};

interface InputProps {
	value?: string;
	onChange?: (value: string) => void;
}

export interface TokenProps {
	input1?: InputProps;
	input2?: InputProps;
}

export const Token = ({ input1, input2 }: TokenProps) => {
	const { t } = useTranslation();
	const { getToken } = useCFPValues();

	return (
		<Box styles={{ flexDirection: 'column', gap: UIHelper.rem(24) }}>
			<ComposableTypographyWithTooltip
				baseProps={{
					appearance: getToken({
						default: {
							default: 'body-100-03',
						},
					}),
				}}
				text={t(resources.title)}
				tags={{}}
				tooltip={{
					title: t(resources.tooltip.title),
					description: t(resources.tooltip.description),
					size: 'xxSmall',
				}}
			/>

			<Box styles={{ gap: UIHelper.rem(12) }}>
				<CFPInputField
					label={t(resources.input1.label)}
					value={input1?.value}
					onChange={(v) => input1?.onChange?.(v || '')}
					secureTextEntry
					infoMessage={[t(resources.input1.hint)]}
				/>

				<CFPInputField
					label={t(resources.input2.label)}
					value={input2?.value}
					onChange={(v) => input2?.onChange?.(v || '')}
					secureTextEntry
					infoMessage={[t(resources.input2.hint)]}
				/>
			</Box>
		</Box>
	);
};
